import { FC } from "react";

interface RightIconProps {
  color?: string;
}

const RightIcon: FC<RightIconProps> = ({ color = "white" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="12" cy="12" r="11.25" stroke={color} strokeWidth="1.5" />
    <path
      d="M7.19995 13.8L11.4 16.8L18 7.2"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RightIcon;
